import { Lock, Crown } from 'lucide-react';
import { Button } from '@/components/ui';
import { useTranslation } from '@parentpath/i18n';

interface ChatLimitPaywallProps {
  questionsUsed: number;
  questionsLimit: number;
  onUpgrade?: () => void;
}

export function ChatLimitPaywall({
  questionsUsed,
  questionsLimit,
  onUpgrade,
}: ChatLimitPaywallProps) {
  const { t } = useTranslation('aiChat');

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full flex items-center justify-center">
          <Lock className="w-8 h-8 text-amber-600" />
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          {t('paywall.title')}
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-4">
          {t('paywall.description', { used: questionsUsed, limit: questionsLimit })}
        </p>

        {/* Reset Info */}
        <p className="text-sm text-gray-500 mb-6">
          {t('paywall.resetInfo')}
        </p>

        {/* Upgrade Button */}
        <Button
          onClick={onUpgrade}
          className="w-full"
        >
          <Crown className="w-4 h-4 mr-2" />
          {t('paywall.upgradeButton')}
        </Button>

        {/* Premium Benefits */}
        <div className="mt-6 text-left bg-gray-50 rounded-lg p-4">
          <p className="text-sm font-medium text-gray-900 mb-2">
            {t('paywall.premiumTitle')}
          </p>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>✓ {t('paywall.benefits.unlimitedQuestions')}</li>
            <li>✓ {t('paywall.benefits.allFeatures')}</li>
            <li>✓ {t('paywall.benefits.adFree')}</li>
            <li>✓ {t('paywall.benefits.prioritySupport')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
